export default __webpack_public_path__ + "static/eureka-8e0b6dcaea72da884d8a86e7cde07ca9.png";